import { render, staticRenderFns } from "./DetailBoxes.vue?vue&type=template&id=0540dfb2&scoped=true&"
import script from "./DetailBoxes.vue?vue&type=script&lang=js&"
export * from "./DetailBoxes.vue?vue&type=script&lang=js&"
import style0 from "./DetailBoxes.vue?vue&type=style&index=0&id=0540dfb2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0540dfb2",
  null
  
)

export default component.exports